import { useMemo } from 'react'
import { useRemoteConfig } from './useRemoteConfigStore'
import { StepOption, StepOptions } from '@order/steps/types'
import { ColorConfig } from '@ca/common/types'
import { StepHrefFn } from '@order/steps/useStepHref'
import { router } from 'expo-router'

const emptyColor: ColorConfig = {
  id: 'none',
  name: 'none',
  code: 'none',
  back: [],
  front: [
    {
      color: '#ffffff',
      opacity: 100,
    },
  ],
}

export const useOptionColors = (
  option: StepOption | undefined,
  href: StepHrefFn
) => {
  const config = useRemoteConfig()
  if (!config) {
    return []
  }
  if (!option?.colors) {
    return []
  }
  return option.colors.map((colorId) => {
    const color = config.colors[colorId]
    const next = href(option.nextStep || null, {
      ...option.select,
      oId: `${option.select?.oId || option.id}`,
      val: color?.code,
    })
    return {
      ...option,
      id: `${option.id}-${colorId}`,
      color,
      value: color?.code,
      title: `color.items.${color?.name}.title`,
      // Rebuild with the color code
      onPress: () => {
        if (!next) {
          return
        }
        router.push(next)
      },
    }
  })
}

export const useColors = () => useRemoteConfig()?.colors ?? {}

const useColor = (colorCode: string | undefined) => {
  const config = useRemoteConfig()

  return useMemo(() => {
    if (!config) {
      return emptyColor
    }
    const vals = Object.values(config.colors)
    const color = vals.find((color) => color.code === colorCode)
    return color || emptyColor
  }, [colorCode, config])
}

export default useColor
